import { Input, InputStructure } from '@tablecheck/tablekit-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PasswordField } from 'components/PasswordField';
import { SignInPageController } from 'pages/SignIn/machine';
import { onInputFocus } from 'utils/input';

export function Content(): JSX.Element | null {
  const [t] = useTranslation();
  const [state, send] = SignInPageController.useActor();
  const {
    context: { email, password, otp, isOtpRequired }
  } = state;

  if (
    state.matches('expiringPassword') ||
    state.matches('expiredPassword') ||
    state.matches('usePasskeys')
  ) {
    return null;
  }

  return (
    <>
      {isOtpRequired ? (
        <InputStructure
          name="otp"
          label={t('forms.otp')}
          input={
            <Input
              type="text"
              id="otp"
              value={otp}
              onChange={(event) => {
                send({
                  type: 'Set OTP',
                  otp: event.target.value
                });
              }}
              onFocus={onInputFocus}
              data-variant={
                state.hasTag('editableOtp') ? undefined : 'disabled'
              }
              data-stretch
              required
            />
          }
        />
      ) : (
        <>
          <InputStructure
            name="email"
            label={t('forms.email')}
            input={
              <Input
                type="email"
                id="email"
                value={email}
                onChange={(event) =>
                  send({
                    type: 'Set Email',
                    email: event.target.value
                  })
                }
                onFocus={onInputFocus}
                data-variant={
                  state.hasTag('editableEmail') ? undefined : 'disabled'
                }
                data-stretch
                required
                autoComplete="email webauthn"
              />
            }
          />
          <PasswordField
            name="password"
            id="password"
            label={t('forms.password')}
            onChangeValue={(value: string) => {
              send({ type: 'Set Password', password: value });
            }}
            onFocus={onInputFocus}
            value={password}
            data-variant={
              state.hasTag('editablePassword') ? undefined : 'disabled'
            }
            required
            autoComplete="current-password webauthn"
          />
        </>
      )}
    </>
  );
}
